import React from 'react';
import {styled} from '@mui/material';
import {
  Body,
  Button,
  designSystemToken,
  Headline,
  Icon,
  Label,
} from '@lightricks/react-design-system';

interface EmptyFilterationResultsProps {
  title: string;
  subtitle?: string;
  ctaText: string;
  onCtaClick: () => void;
}

const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '0 0 32px 0',
  width: '100%',
  height: '100%',
  boxSizing: 'border-box',
});

const ContentWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  alignItems: 'center',
  width: '100%',
});

const IconTitleWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  alignItems: 'center',
});

const IconWrapper = styled('div')({
  width: '48px',
  height: '48px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
});

function EmptyFilterationResults({
  title,
  subtitle,
  ctaText,
  onCtaClick,
}: EmptyFilterationResultsProps) {
  return (
    <Container>
      <ContentWrapper>
        <IconTitleWrapper>
          <IconWrapper>
            <Icon
              size="large"
              appearance="neutral"
              name="Actions-Search-Generic"
              style={{width: '48px', height: '48px'}}
              color={designSystemToken('semantic.fg.tertiary')}
            />
          </IconWrapper>

          <Headline size="sm" color={designSystemToken('semantic.fg.neutral')}>
            {title}
          </Headline>
        </IconTitleWrapper>
        {subtitle ? (
          <Body size="sm" color={designSystemToken('semantic.fg.secondary')}>
            {subtitle}
          </Body>
        ) : null}
      </ContentWrapper>
      <Button
        appearance="neutral"
        mode="tinted"
        size="small"
        onClick={onCtaClick}
      >
        <Label size="md" color={designSystemToken('semantic.fg.neutral')}>
          {ctaText}
        </Label>
      </Button>
    </Container>
  );
}

export default EmptyFilterationResults;
